// extracted by mini-css-extract-plugin
export var text = "_k-0";